import { UnderlyingTag } from 'components/underlying-tag';
import { useUnderlyingCodeType } from 'hooks/useUnderlyingCodeType';
import type { Underlying } from 'models/underlying';
import { FC } from 'react';
import { getUnderlyingCode } from 'utils/underlying/underlying-code';

export type UnderlyingBadgesListProps = {
  underlyings: ReadonlyArray<Underlying>;
};

export const UnderlyingBadgesList: FC<UnderlyingBadgesListProps> = ({ underlyings }) => {
  return (
    <div className="d-flex flex-wrap gap-2">
      {underlyings.map(underlying => (
        <UnderlyingBadge underlying={underlying} key={underlying.id} />
      ))}
    </div>
  );
};

export type UnderlyingBadgeProps = {
  underlying: Readonly<Underlying>;
  className?: string;
};

export const UnderlyingBadge: FC<UnderlyingBadgeProps> = ({ underlying, className }) => {
  const defaultUnderlyingCodeType = useUnderlyingCodeType();
  return (
    <UnderlyingTag
      label={getUnderlyingCode(underlying, defaultUnderlyingCodeType)}
      value={underlying}
      className={className}
      isReadOnly
      dataE2e="underlying-badge"
    />
  );
};

UnderlyingBadge.displayName = 'UnderlyingBadge';
